import { render, staticRenderFns } from "./BoardHistoryModal.vue?vue&type=template&id=b7fdf0a6&scoped=true"
import script from "./BoardHistoryModal.vue?vue&type=script&lang=js"
export * from "./BoardHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./BoardHistoryModal.vue?vue&type=style&index=0&id=b7fdf0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fdf0a6",
  null
  
)

export default component.exports